import { EntityReferences, ExternalEntityReferences } from "../models/mappers";
import { EntityName, ExternalEntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const onboardingHubProfileFields = [
  "gaming_onboardinghubprofileid", // UID
  "ownerid", // Owner
  "gaming_onboardinghubcreated", // Boolean
  "gaming_ndasent", // Boolean
  "gaming_ggp_ndasent", // Date
  "gaming_ndareceived", // Boolean
  "gaming_ggp_ndareceived", // Date
  "modifiedon", // Date
  "gaming_ndaonhubcreated", // Boolean
  "gaming_ndasigneddate", // Date
  "gaming_ndaapierrormessage", // Text

  // Original Contact fields
  "gaming_contact_firstname", // Text
  "gaming_contact_lastname", // Text
  "gaming_contact_jobtitle", // Text
  "gaming_contact_emailaddress1", // Email
  "gaming_onboardinguserid", // Text
  "gaming_contact_telephone1", // Phone
  "gaming_ndacontractnumber", // Text

  // Original Account fields
  "gaming_ResultingAccountId", // Lookup - account
  "gaming_account_name", // Text
  "gaming_account_mspcverifiedaccountname", // Text
  "gaming_account_ggp_legalentitynameifdifferent", // Text
  "gaming_account_ggp_businessimpact", // Choice
  "gaming_account_ggp_primaryaccounttype", // Choice
  "gaming_account_ggp_secondaryaccounttype", // Choice
  "gaming_account_ggp_accounttype", // Choice
  "gaming_account_ggp_udcsellerid", // Text
  "gaming_account_playfab_leadsource", // Choice
  "gaming_account_playfab_leadsourcedetailed", // Text
  "gaming_Account_Address1CountryRegionId", // Lookup - country/region
  "gaming_account_address1_line1", // Text
  "gaming_account_address1_line2", // Text
  "gaming_account_address1_city", // Text
  "gaming_account_address1_stateorprovince", // Text
  "gaming_account_address1_postalcode", // Text
  "gaming_account_address1_telephone1", // Phone
  "gaming_account_address1_addresstypecode", // Choice
  "gaming_account_address1_country", // Text
  "gaming_account_address2_line1", // Text
  "gaming_account_address2_line2", // Text
  "gaming_account_address2_city", // Text
  "gaming_account_address2_stateorprovince", // Text
  "gaming_account_address2_postalcode", // Text
  "gaming_Account_Address2CountryRegionId", // Lookup - country/region
  "gaming_account_address2_country", // Text
  "gaming_account_address2_telephone1", // Phone
  "gaming_account_address2_addresstypecode", // Choice
  "gaming_account_onboardingndaid", // GUID
  "gaming_account_websiteurl", // Text
  "gaming_account_dsa_addressline1",
  "gaming_account_dsa_addressline2",
  "gaming_account_dsa_city",
  "gaming_account_dsa_stateorprovidence",
  "gaming_account_dsa_postalcode",
  "gaming_Account_DSA_CountryRegionId",
  "gaming_account_dsa_telephone",
  "gaming_account_dsa_emailaddress",
  "gaming_account_dsa_websiteurl",
  "gaming_account_soleproprietor", // Boolean
  "gaming_account_telephone1", // Text
  "gaming_referralparameter", // Text
  "gaming_referralparameterdate", // Date
  "gaming_dunsnumber", // Text

  // Partner center status
  "gaming_sellerstatus", // Choice
  "gaming_appdevstatus", // Choice
  "gaming_devrolestatus", // Choice
  "gaming_partnercenterpreexistingaccounttype", // Choice

  // Re Send NDA
  "gaming_sendnewnda", // Choice - YesNo
  "gaming_ndaresendapistatus", // Choice
  "gaming_ndaresendapiresponse", // Text
  "gaming_historicalonboardingndaid", // Text
  "gaming_historicalndasigneddate", // Date
  "gaming_historicalndacontractnumber", // Text

  // OneVet
  "gaming_vettingcompanyemail", // Text
  "gaming_vettingid", // Text
  "gaming_vettingstatus", // Choice
  "gaming_vettingemailverificationstatus", // Choice
] as const;

export const onboardingHubProfileReferences: EntityReferences<EntityName.gaming_onboardinghubprofile> =
  {
    [EntityName.ggp_country]: [
      "gaming_Account_Address1CountryRegionId",
      "gaming_Account_Address2CountryRegionId",
      "gaming_Account_DSA_CountryRegionId",
    ],
    [EntityName.account]: ["gaming_ResultingAccountId"],
  };

export const onboardingHubProfileExternalReferences: ExternalEntityReferences<EntityName.gaming_onboardinghubprofile> =
  {
    [ExternalEntityName.team]: ["ownerid"],
  };

export const onboardingHubProfileKey: AnyEntityField<EntityName.gaming_onboardinghubprofile> =
  "gaming_onboardinghubprofileid";
